export function ordinalSuffix(value: number): string {
  const absolute = Math.abs(Math.trunc(value));
  const lastTwo = absolute % 100;
  if (lastTwo >= 11 && lastTwo <= 13) return 'th';
  switch (absolute % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

export function ordinal(value: number): string {
  return `${Math.trunc(value)}${ordinalSuffix(value)}`;
}
